import React, {useState, useEffect} from 'react';
import PropTypes from 'prop-types'

export const Checkbox = ({
                           incomplete,
                           side,
                           field,
                           checked,
                           callBack,
                           enabled,
                           children,
                         }) => {

  const checkSide = side || 'left';

  const getCheck = () => {
    if (!checked) return null;

    if (incomplete)
      return <path d="M5.5 9.5H12.5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>;

    return <path d="M4.91675 10.0835L7.25008 12.4168L13.0834 6.5835" stroke="white" strokeWidth="2"
                 strokeLinecap="round" strokeLinejoin="round"/>
  }

  const handleChange = (e) => {
    if (!enabled) return;

    callBack(e.target.checked, field);
  }

  return (
    <label
      htmlFor={field}
      className={`checkbox ${checkSide} ${checked ? 'checked' : ''} ${!enabled ? 'disabled' : ''}`}
    >
      {checkSide === 'right' && <span className="label">{children}</span>}
      <svg width="18" height="19" viewBox="0 0 18 19" fill="none" xmlns="http://www.w3.org/2000/svg">
        <rect x="1" y="1.5" width="16" height="16" rx="4" fill="#186ACD" stroke="#38373C" strokeWidth="2"/>
        {getCheck()}
      </svg>
      {checkSide === 'left' && <span className="label">{children}</span>}

      <input
        type="checkbox"
        id={field}
        checked={checked}
        disabled={!enabled}
        onChange={handleChange}
      />
    </label>
  )
}


Checkbox.propTypes = {
  incomplete: PropTypes.bool,
  side: PropTypes.oneOf(['left', 'right']),
  field: PropTypes.string,
  checked: PropTypes.bool,
  callBack: PropTypes.func,
  enabled: PropTypes.bool,
  children: PropTypes.node,
}

Checkbox.defaultProps = {
  incomplete: false,
  side: 'left',
  field: 'default',
  checked: false,
  callBack: (checked, field) => undefined,
  enabled: true,
  children: null,
}
